import { Button, Dialog, Intent } from "construct-ui";
import moment from 'moment';
import ConfirmationDialogView from '../../components/common/confirmation-box.view';
import fileInputComponent from "../../components/common/file-input-component";
import multipleSelectListComponent from "../../components/common/multiple-select-common.component";
import SingleSelectCommonComponentView from "../../components/common/single-select-common-component.view";
import textInputComponent from "../../components/common/text-input.component";
import DatePickerComponent from "../../components/date-picker/date-picker.component";
import { messageComponent } from "../../components/message/message.component";
import MultiSelectComponent from "../../components/multi-select/multi-select.component";
import SelectSiteComponent from "../../components/site/select-site.component";
import SelectUserComponent from "../../components/user/select-user.component";
import { formats as FORMATS, codeMasterType } from "../../config/constants";
import codeMasterModel from "../../models/common/code-master.model";
import fileModel from "../../models/common/file.model";
import userSearchModal from "../../models/common/user-search.modal";
import loginModel from "../../models/login.model";
import modelBase from "../../models/model-base.model";
import surveyModel from "../../models/survey/survey.model";
import ViewBase from "../view-base.view";

export default function SurveyRegisterView() {
  ViewBase.call(this);

  let onRegisterCompleted = (id) => { };
  let onGoBack = () => { };
  let _isCopyOpen = false;
  let _isCopySucceed = false;
  let _isPreviewOpen = false;
  let _base64Image = "";
  let needReset = true;
  let surveyId = "";
  let surveyIdString = "";
  let isMsgOpen = false;
  let msgTitle = "";
  let showMsg = "";
  let isSubmitted = false;
  let isEdit = false;
  let fromInitDate;
  let toInitDate;
  let surveyName = "";
  let needBackDayLimit = true;

  let _attachment = { file: undefined, filename: '', fileID: '' };
  let surveyTypeList = [];
  let codemastertypeList = [];
  let gscmDivList = [];
  let frequencyList = [];
  let resultCopyList = [];
  let statusList = [{ code: "Y", name: "Yes" }, { code: "N", name: "No" }];
  let dayList = [];
  let userRoles = [];

  let inputFilter = {
    title: "",
    gscmDivision: [],
    site: { selectedSiteList: [], selectedSiteListArr: [], selectedSitesTxt: "" },
    category: "",
    users: { selectedUserList: [] },
    selectedUserRoles: [],
    sites: { selectedSitesList: [], selectedSitesListArr: [], selectedSitesTxt: "" },
    channelGroup: "",
    surveyType: { name: "", code: "" },
    type: { name: "", code: "" },
    fromDate: "",
    toDate: "",
    frequency: { name: "", code: "" },
    status: "",
    resultCopy: { name: "", code: "" },
    description: "",
    sequence: "",
    photo: {},
    photoForm: null,
    photoGuid: '00000000-0000-0000-0000-000000000000',
    selectedBackDaysLimit: { name: "", code: "" },
    selectedLSVNYN: { name: "No", code: "N" },
    backDateYN: "N"
  };

  let _filePreview = (fileMasterId) => {
    fileModel.getSurveyImageFile(
      (result) => {
        _isPreviewOpen = true;
        _base64Image = result.fileContent;
      },
      (error) => {
        this.handleError(error);
      },
      fileMasterId
    )
  }

  let _validateAll = () => {
    if (inputFilter.surveyType.code == "" || inputFilter.title == "" || inputFilter.sequence == "" || inputFilter.sequence == null || (isEdit && inputFilter.status.code == "")) {
      return false;
    }
    else {
      if (inputFilter.surveyType.code == "N") {
        if (inputFilter.frequency.code == "") {
          return false;
        } else if (inputFilter.frequency.code != "" && inputFilter.frequency.code != "NONE" && inputFilter.resultCopy.code == "") {
          return false;
        } else if (inputFilter.type.code == "") {
          return false;
        } else if (inputFilter.type.code == "STORE") {
          if (inputFilter.sites.selectedSitesList.length == 0) {
            return false;
          }
        }
      } else if (inputFilter.surveyType.code == "Q") {
        if (inputFilter.type.code == "") {
          return false;
        } else if (inputFilter.type.code == "STORE") {
          if (inputFilter.sites.selectedSitesList.length == 0) {
            return false;
          }
        }
      }
    }

    return true;
  }

  let _onDatePickerChange = (e) => {
    fromInitDate = moment(e.detail.start).format(FORMATS.dateFormat);
    toInitDate = moment(e.detail.end).format(FORMATS.dateFormat);
    inputFilter.fromDate = moment(e.detail.start).format(FORMATS.apiDateFormat);
    inputFilter.toDate = moment(e.detail.end).format(FORMATS.apiDateFormat);
  }

  let getUserRoles = (countryCode) => {
    userSearchModal.getUserRoleList(
      (result) => {
        userRoles = result;
      },
      (error) => {
        this.handleError(error);
      },
      countryCode);
  }

  let fileChange = (e) => {
    _attachment.file = e.files[0];
    _attachment.filename = e.files[0]?.name || '';
    inputFilter.photoGuid = e.files[0]?.name || '';
    inputFilter.photo = _attachment;
    inputFilter.photoForm = new FormData();
    inputFilter.photoForm.append("file", e.files[0]);
  }

  let fileClear = (e) => {
    _attachment.file = [];
    _attachment.filename = "";
    inputFilter.photo = null;
    inputFilter.photoForm = null;
    inputFilter.photoGuid = '00000000-0000-0000-0000-000000000000';
  }

  let finalizeData = (viewState) => {
    isSubmitted = true;
    let isValid = _validateAll();
    if (isValid) {
      if (inputFilter?.photo?.file != undefined && inputFilter.photoGuid != '') {
        modelBase.uploadfile((result) => {
          inputFilter.photoGuid = result[0].id;
          submit(viewState);
        }, (error) => {
          log.e(error);
        }, inputFilter?.photo?.file, 'Survey');
      } else {
        return submit(viewState);
      }
    }
  }

  let BeforeCopyData = () => {
    _isCopyOpen = true;
  }

  let CopyData = () => {
    this.showLoading();
    _isCopyOpen = false;
    surveyModel.copySurvey(
      (result) => {
        _isCopySucceed = true;
        this.hideLoading();
        surveyId = result[0].id;
        isMsgOpen = true;
        showMsg = result[0].message;
        msgTitle = result[0].transStatus;
      }, (error) => {
        _isCopySucceed = false;
        this.hideLoading();
        this.handleError(error);
      }, surveyId);
  }

  let generateObject = (result) => {
    inputFilter.surveyType = { code: result.surveyType, name: result.surveyTypeName };
    inputFilter.title = result.title;
    surveyName = "[Update]-" + result.title;
    inputFilter.gscmDivision = result.gscmDiv.split('^');
    inputFilter.category = result.category;
    inputFilter.sequence = result.displaySeq;
    inputFilter.status = { code: result.active, name: result.active == "Y" ? "Yes" : "No" };
    inputFilter.description = result.description;
    inputFilter.photoGuid = result.photoGUID;
    inputFilter.photo = {};
    inputFilter.photoForm = null;
    inputFilter.type = { code: result.type, name: result.typeName };

    if (result.frequency == '') {
      inputFilter.frequency = { code: 'NONE', name: 'None' };
    } else {
      inputFilter.frequency = { code: result.frequency, name: result.frequencyName };
    }

    inputFilter.resultCopy = { code: result.resultCopy, name: result.resultCopyName };

    toInitDate = moment(result.toDate).format(FORMATS.dateFormat);
    fromInitDate = moment(result.fromDate).format(FORMATS.dateFormat);

    inputFilter.fromDate = moment(fromInitDate, FORMATS.dateFormat).format(FORMATS.apiDateFormat);
    inputFilter.toDate = moment(toInitDate, FORMATS.dateFormat).format(FORMATS.apiDateFormat);
    inputFilter.selectedLSVNYN = { name: result.lsvyn == "N" ? "No" : "Yes", code: result.lsvyn };
    inputFilter.backDateYN = result.backDateLimitYN;
    inputFilter.selectedBackDaysLimit = { name: result.backDateLimitDays.toString(), code: result.backDateLimitDays.toString() };

    let userList = result.surveyMap.filter(x => x.type == "USER_ID");
    let userRoleList = result.surveyMap.filter(x => x.type == "UserRole");
    let siteList = result.surveyMap.filter(x => x.type == "CHANNEL_CD");

    if (userList.length > 0) {
      userList.forEach(function (item) {
        inputFilter.users.selectedUserList.push({ userName: item.name, userID: item.code });
      });
    }

    if (userRoleList.length > 0) {
      userRoleList.forEach(function (item) {
        inputFilter.selectedUserRoles.push({ name: item.name, code: item.code });
      });
    }

    if (siteList.length > 0) {
      siteList.forEach(function (item) {
        inputFilter.sites.selectedSitesTxt += item.name + ",";
        inputFilter.sites.selectedSitesListArr.push(item.code);
        inputFilter.sites.selectedSitesList.push({ name: item.name, code: item.code, sequence: "1" });
      });
    }

    if (inputFilter.surveyType.code == "N" && result.backDateLimitYN == "Y") {
      inputFilter.selectedLSVNYN = { name: "No", code: "N" };
      inputFilter.frequency = { name: "Daily", code: "DAILY" };
      inputFilter.resultCopy = { name: "None", code: "NONE" };
      inputFilter.selectedLSVNYN = { name: "No", code: "N" };
    }
    needReset = true;
  }

  let getCodemasterData_surveyTypeList = (country) => {
    codeMasterModel.getByCategory(
      (result) => {
        surveyTypeList = [];
        result.forEach(function (item) {
          surveyTypeList.push({ code: item.code, name: item.name });
        });
      },
      (error) => {
        surveyTypeList = [];
        log.e({ error: error, params: { category: codeMasterType.SurveyType, countryCode: country } });
      },
      { category: codeMasterType.type, countryCode: country }
    );
  }

  let getCodemasterData_typeList = (country) => {
    codeMasterModel.getByCategory(
      (result) => {
        codemastertypeList = [];
        result.forEach(function (item) {
          codemastertypeList.push({ code: item.code, name: item.name });
        });
      },
      (error) => {
        codemastertypeList = [];
        log.e({ error: error, params: { category: codeMasterType.normalSurveyType, countryCode: country } });
      },
      { category: codeMasterType.normalSurveyType, countryCode: country }
    );
  }

  let getCodemasterData_gscmdiv = (country) => {
    codeMasterModel.getByCategory(
      (result) => {
        gscmDivList = [];
        result.forEach(function (item) {
          gscmDivList.push({ code: item.code, name: item.name });
        });
      },
      (error) => {
        gscmDivList = [];
        log.e({ error: error, params: { category: codeMasterType.gscmDiv, countryCode: country } });
      },
      { category: codeMasterType.gscmDiv, countryCode: country }
    );
  }

  let getCodemasterData_frequency = (country) => {
    codeMasterModel.getByCategory(
      (result) => {
        frequencyList = [];
        result.forEach(function (item) {
          frequencyList.push({ code: item.code, name: item.name });
        });
      },
      (error) => {
        codemastertypeList = [];
        log.e({ error: error, params: { category: codeMasterType.frequency, countryCode: country } });
      },
      { category: codeMasterType.frequency, countryCode: country }
    );
  }

  let getCodemasterData_resultcopy = (country) => {
    codeMasterModel.getByCategory(
      (result) => {
        resultCopyList = [];
        result.forEach(function (item) {
          resultCopyList.push({ code: item.code, name: item.name });
        });
      },
      (error) => {
        resultCopyList = [];
        log.e({ error: error, params: { category: codeMasterType.resultCopy, countryCode: country } });
      },
      { category: codeMasterType.resultCopy, countryCode: country }
    );
  }

  let getBySurveyId = () => {
    this.showLoading();
    surveyModel.getSurveyDetails(
      (result) => {
        this.hideLoading();
        generateObject(result);
      }, (error) => {
        this.hideLoading();
        this.handleError(error);
      },
      surveyId);
  }

  let getBackDateConfg = () => {
    surveyModel.getBackDateDetails(
      (result) => {
        if (result.backDateLimitYN == "Y") {
          needBackDayLimit = true;
          dayList = [];
          for (let i = 0; i <= Number(result.backDateLimitDays); i++) {
            dayList.push({ code: i.toString(), name: i.toString() });
          }
        }
        else {
          needBackDayLimit = false;
          dayList = [];
        }
      }, (error) => {
        this.handleError(error);
      });
  }

  let submit = (viewState) => {

    let params = {
      "title": inputFilter.title,
      "surveyType": inputFilter.surveyType.code,
      "fromDate": inputFilter.fromDate,
      "toDate": inputFilter.toDate,
      "gscmDiv": inputFilter.gscmDivision.join('^'),
      "targetUserId": inputFilter.users.selectedUserList.map(u => u.userID).join('^'),
      "targetUserRoleCode": inputFilter.selectedUserRoles.map(r => r.code).join('^'),
      "type": (inputFilter.surveyType.code == "N" || inputFilter.surveyType.code == "Q") ? inputFilter.type.code : "USER",
      "frequency": inputFilter.frequency.code == "NONE" ? '' : inputFilter.frequency.code,
      "description": inputFilter.description,
      "category": inputFilter.category,
      "displaySeq": inputFilter.sequence,
      "resultCopy": inputFilter.resultCopy.code,
      "photoGUID": inputFilter.photoGuid,
      "targetSiteId": inputFilter.sites.selectedSitesListArr.join('^'),
      "lsvyn": inputFilter.selectedLSVNYN.code,
      "backDateLimitYN": needBackDayLimit ? inputFilter.backDateYN : "N",
      "backDateLimitDays": inputFilter.backDateYN == "Y" ? inputFilter.selectedBackDaysLimit.code : "0"
    };

    if (inputFilter.surveyType.code == "Y" || inputFilter.surveyType.code == "Q") {
      params.backDateLimitYN = "N";
      params.backDateLimitDays = "0";
    }

    if (isEdit) {
      params["surveyId"] = surveyId;
      params["useYN"] = inputFilter.status.code;
    }

    surveyModel.saveSurvey(
      (result) => {
        this.hideLoading();
        surveyId = result[0].id;
        isMsgOpen = true;
        showMsg = result[0].message;
        msgTitle = result[0].transStatus;

        viewState.clearState();
      }, (error) => {
        this.hideLoading();
        this.handleError(error);
      },
      params, isEdit);
  }

  let onClear = () => {

    inputFilter = {
      title: "",
      gscmDivision: [],
      site: { selectedSiteList: [], selectedSiteListArr: [], selectedSitesTxt: "" },
      category: "",
      users: { selectedUserList: [] },
      selectedUserRoles: [],
      sites: { selectedSitesList: [], selectedSitesListArr: [], selectedSitesTxt: "" },
      channelGroup: "",
      surveyType: [],
      type: [],
      fromDate: "",
      toDate: "",
      frequency: [],
      status: [],
      resultCopy: [],
      description: "",
      sequence: "",
      photo: {},
      photoForm: null,
      photoGuid: '00000000-0000-0000-0000-000000000000',
      selectedBackDaysLimit: { name: "", code: "" },
      selectedLSVNYN: { name: "No", code: "N" },
      backDateYN: "N"
    };

    toInitDate = moment().add(1, 'weeks').format(FORMATS.dateFormat);
    fromInitDate = moment().format(FORMATS.dateFormat);
    inputFilter.fromDate = moment(fromInitDate, FORMATS.dateFormat).format(FORMATS.apiDateFormat);
    inputFilter.toDate = moment(toInitDate, FORMATS.dateFormat).format(FORMATS.apiDateFormat);
  }

  let redirect = () => {
    if (_isCopySucceed) {
      onGoBack();
    } else {
      onRegisterCompleted(surveyId);
    }
  }

  const ErrorMessageComponent = () => {
    return {
      view: ({ attrs: {
        message = this.getText('LT00000729', 'This field is required')
      } }) => [
          m('.d-block.invalid-feedback', message)
        ]
    }
  }

  const SectionGeneralInformation = () => {
    return {
      view: () => [
        m('h2', this.getText("LT00000223", "General Information")),
        m('hr.mt-3.mb-4'),
        m('.row.g-3',
          m('.col-md-4',
            m('.col',
              m('label.form-label.mandatory', this.getText("LT00000351", "Survey Type")),
              m(SingleSelectCommonComponentView, {
                disabled: isEdit,
                iconList: [],
                items: surveyTypeList,
                selectedItem: inputFilter.surveyType,
                handleSelect: (sItem) => {
                  inputFilter.surveyType = sItem;
                  inputFilter.frequency = { code: "", name: "" };
                  inputFilter.resultCopy = { code: "", name: "" };
                  inputFilter.type = { code: "", name: "" };
                }
              }),
              (isSubmitted && inputFilter.surveyType.code == "") &&
              m(ErrorMessageComponent, { message: this.getText("EM00000349", "Please select a survey type") })
            ),
          ),
          m('.col-md-4',
            m(textInputComponent, {
              label: this.getText("LT00000348", "Survey Category"),
              placeholder: this.getText("LT00000348", "Survey Category"),
              value: inputFilter.category,
              onchange: (e) => { inputFilter.category = e.target.value; },
              mandatory: false,
              isvalid: 1,
              disabled: parseInt(surveyIdString) < 0
            }),
          ),
          m('.col-md-4',
            m('label.form-label.mandatory', this.getText("LT00000354", "Survey Display Sequency")),
            m("input.form-control", {
              "type": "number",
              "min": "1",
              "value": inputFilter.sequence,
              onkeyup: (e) => {
                if (this._allowOnlyNumbers(e)) {
                  inputFilter.sequence = e.target.value
                } else {
                  return false;
                }
              },
              onchange: (e) => {
                inputFilter.sequence = e.target.value;
              }
            }),
            (isSubmitted && (inputFilter.sequence == "" || inputFilter.sequence == null)) &&
            m(ErrorMessageComponent, { message: this.getText("EM00000237", "Please enter sequence") })
          ),
          m('.col-md-4',
            m(textInputComponent, {
              label: this.getText("LT00000037", "Title"),
              placeholder: this.getText("LT00000037", "Title"),
              value: inputFilter.title,
              onchange: (e) => { inputFilter.title = e.target.value; },
              mandatory: true,
              isvalid: (isSubmitted && inputFilter.title == "") ? 0 : 1,
              errorMessage: this.getText("EM00000350", "Please enter title"),
              validate: _validateAll
            }),
          ),
          m('.col-md-4',
            m('.col',
              m('label.form-label.mandatory', this.getText("LT00000241", "GSCM Division")),
              needReset && m(multipleSelectListComponent, {
                items: gscmDivList, selectedList: inputFilter.gscmDivision, handleSelect: (selectedList) => {
                  inputFilter.gscmDivision = selectedList;
                }
              }),
              (isSubmitted && inputFilter.gscmDivision.length == 0) &&
              m(ErrorMessageComponent, { message: this.getText("EM00000351", "Please select a GSCM Type") })
            ),
          ),
          (inputFilter.surveyType.code == "N" || inputFilter.surveyType.code == "Q") && m('.col-md-4',
            m('.col',
              m('label.form-label.mandatory', this.getText("LT00000117", "Type")),
              m(SingleSelectCommonComponentView, {
                disabled: false,
                iconList: [],
                items: codemastertypeList,
                selectedItem: inputFilter.type,
                handleSelect: (sItem) => {
                  inputFilter.type = sItem;
                  inputFilter.sites.selectedSitesTxt = "";
                  inputFilter.sites.selectedSitesList = [];
                  inputFilter.sites.selectedSitesListArr = [];
                }
              }),
              (isSubmitted && inputFilter.type.code == "") &&
              m(ErrorMessageComponent, { message: this.getText("EM00000352", "Please select a type") })
            ),
          ),
          m('.col-md-4',
            m('label.form-label.mandatory', this.getText("LT00000150", "Period")),
            m(DatePickerComponent, {
              class: 'form-control',
              isRange: true,
              dateStart: fromInitDate, // default date range
              dateEnd: toInitDate, // default date range
              grid: 1,
              calendars: 1,
              onselect: (e) => {
                _onDatePickerChange(e);
              }
            }),
            (isSubmitted && (inputFilter.fromDate == "" || inputFilter.toDate == "")) &&
            m(ErrorMessageComponent, { message: this.getText("EM00000353", "Invalid date range selection") })
          ),
          isEdit && m('.col-md-4',
            m('.col',
              m('label.form-label.mandatory', this.getText("LT00000015", "Status")),
              m(SingleSelectCommonComponentView, {
                disabled: false, iconList: [], items: statusList, selectedItem: inputFilter.status, handleSelect: (sItem) => {
                  inputFilter.status = sItem;
                }
              }),

              (isSubmitted && inputFilter.status.code == "") &&
              m(ErrorMessageComponent, { message: this.getText("EM00000355", "Please select a status") })
            ),
          ),
          m('.col-md-4',
            m('label.form-label', this.getText("LT00000012", "Description")),
            m("input", { "class": "form-control form-control-bg", "type": "text", "value": inputFilter.description, onchange: (e) => { inputFilter.description = e.target.value } })
          ),
          m('.col-md-4',
            m(fileInputComponent, {
              label: this.getText("LT00000259", "Photo"),
              onchange: fileChange,
              accept: '.png,.jpeg,.jpg',
              onClear: () => { inputFilter.photoGuid = ""; fileClear() },
              onPreview: (id) => {
                _filePreview(id);
              },
              fileID: inputFilter.photoGuid
            })
          ),
        ),
      ]
    }
  }

  const SectionTargetInformation = () => {
    return {
      view: () => [
        m('h2', this.getText("LT00000550", "Target Information")),
        m('hr.mt-3.mb-4'),
        m('.row.g-3',
          m('.col-md-4', m('label.form-label', this.getText("LT00000349", "Target User")),
            m(SelectUserComponent, {
              default: {
                userStatusCode: '0001'
              },
              onSelect: (u) => {
                inputFilter.users.selectedUserList = u;
              },
              selectedUserList: inputFilter.users.selectedUserList,
            }),
          ),
          m('.col-md-4.col-lg-4',
            m('label.form-label', this.getText("LT00000497", "Target user Roles")),
            m(MultiSelectComponent, {
              items: userRoles,
              selectedItems: inputFilter.selectedUserRoles,
              onSelect: (u) => {
                inputFilter.selectedUserRoles = u;
              }
            }),
          ),
          inputFilter.type.code == "STORE" && m('.col-md-4', m('label.form-label.mandatory', this.getText("LT00000496", "Target Sites")),
            m(SelectSiteComponent, {
              selectedItemList: inputFilter.sites.selectedSitesList,
              onChange: (s) => {
                inputFilter.sites.selectedSitesListArr = [];
                inputFilter.sites.selectedSitesList = s;
                inputFilter.sites.selectedSitesListArr = inputFilter.sites.selectedSitesList.map(s => s.code);
              }
            }),
            (isSubmitted && inputFilter.sites.selectedSitesListArr.length == 0) &&
            m(ErrorMessageComponent, { message: this.getText("EM00000356", "Please select target sites") })
          ),
        ),
      ]
    }
  }

  const SectionOtherInformation = () => {
    return {
      view: () => [
        m('h2', this.getText("LT00000551", "Other Information")),
        m('hr.mt-3.mb-4'),
        m('.row.g-3',
          (needBackDayLimit && inputFilter.surveyType.code == "N") && m('.col-md-2',
            m('.col-md-12',
              m('label.form-label', this.getText("LT00000552", "Allow Backdate YN")),
            ),
            m('.col-md-12',
              m('input[type="checkbox"].form-check-input',
                {
                  style: "margin-right:7px",
                  checked: inputFilter.backDateYN == "Y" ? true : false,
                  onclick: (e) => {
                    inputFilter.backDateYN = e.target.checked ? "Y" : "N";
                    if (e.target.checked) {
                      inputFilter.selectedBackDaysLimit = { name: "2", code: "2" };
                      inputFilter.frequency = { name: "Daily", code: "DAILY" };
                      inputFilter.resultCopy = { name: "None", code: "NONE" };
                      inputFilter.selectedLSVNYN = { name: "No", code: "N" };
                    }
                    else {
                      inputFilter.selectedBackDaysLimit = { name: "", code: "" };
                      inputFilter.frequency = { name: "", code: "" };
                      inputFilter.resultCopy = { name: "", code: "" };
                    }
                  }
                }
              )
            )
          ),
          (inputFilter.backDateYN == "Y" && inputFilter.surveyType.code == "N") && m('.col-md-2',
            m('.col-md-12',
              m('label.form-label', this.getText("LT00000553", "Back Date Limit Days")),
              m(SingleSelectCommonComponentView, {
                disabled: false, iconList: [], items: dayList, selectedItem: inputFilter.selectedBackDaysLimit, handleSelect: (sItem) => {
                  inputFilter.selectedBackDaysLimit = sItem;
                }
              })
            ),
          ),
          (inputFilter.surveyType.code == "N") && m('.col-md-2',
            m('.col',
              m('label.form-label.mandatory', this.getText("LT00000353", "Frequency")),
              m(SingleSelectCommonComponentView, {
                disabled: inputFilter.backDateYN == "Y", iconList: [], items: frequencyList, selectedItem: inputFilter.frequency, handleSelect: (sItem) => {
                  inputFilter.frequency = sItem;
                  inputFilter.resultCopy = { code: "", name: "" };
                }
              }),
              (isSubmitted && inputFilter.frequency.code == "") &&
              m(ErrorMessageComponent, { message: this.getText("EM00000354", "Please select a frequency") })
            ),
          ),
          ((inputFilter.surveyType.code == "N" || inputFilter.surveyType.code == "Q") && inputFilter.frequency.code != "NONE" && inputFilter.frequency.code != "") && m('.col-md-2',
            m('.col',
              m('label.form-label.mandatory', this.getText("LT00000355", "Result Copy")),
              m(SingleSelectCommonComponentView, {
                disabled: inputFilter.backDateYN == "Y", iconList: [], items: resultCopyList, selectedItem: inputFilter.resultCopy, handleSelect: (sItem) => {
                  inputFilter.resultCopy = sItem;
                }
              }),
              (isSubmitted && inputFilter.resultCopy.code == "") &&
              m(ErrorMessageComponent, { message: this.getText("EM00000373", "Please select result copy") })
            ),
          ),
          (inputFilter.surveyType.code == "N" || inputFilter.surveyType.code == "Y") && m('.col-md-2',
            m('label.form-label', this.getText("LT00000554", "LSV YN"),
              m('span.redText', "*")
            ),
            m(SingleSelectCommonComponentView, {
              disabled: inputFilter.backDateYN == "Y", iconList: [], items: statusList, selectedItem: inputFilter.selectedLSVNYN, handleSelect: (sItem) => {
                inputFilter.selectedLSVNYN = sItem;
              }
            })
          ),
        ),
      ]
    }
  }

  return {
    oninit: function (vnode) {
      let country = loginModel.credentials.country;
      getBackDateConfg();
      getCodemasterData_surveyTypeList(country);
      getCodemasterData_typeList(country);
      getCodemasterData_gscmdiv(country);
      getCodemasterData_resultcopy(country);
      getCodemasterData_frequency(country);
      getUserRoles(country);

      if (vnode.attrs.onOpenQuestionList) {
        onRegisterCompleted = vnode.attrs.onOpenQuestionList;
      }

      if (vnode.attrs.onGoBack) {
        onGoBack = vnode.attrs.onGoBack;
      }

      if (vnode.attrs.surveyId) {
        surveyId = vnode.attrs.surveyId;
        if (surveyId != "") {
          isEdit = true;
          needReset = false;
          getBySurveyId();
        }
      }

      if (vnode.attrs.surveyIdString) {
        surveyIdString = vnode.attrs.surveyIdString;
      }

      toInitDate = moment().add(1, 'weeks').format(FORMATS.dateFormat);
      fromInitDate = moment().format(FORMATS.dateFormat);
      inputFilter.fromDate = moment(fromInitDate, FORMATS.dateFormat).format(FORMATS.apiDateFormat);
      inputFilter.toDate = moment(toInitDate, FORMATS.dateFormat).format(FORMATS.apiDateFormat);
    },
    view: (vnode) => {
      return [m('.row',
        m(".col-12",
          surveyName != "" &&
          m('.w-100',
            m('h2',
              m('i.bi.bi-arrow-left.cursor-pointer', {
                onclick: () => {
                  onGoBack();
                }
              }),
              surveyName
            )
          ),
          m('.card.mb-3',
            m('.card-body.pt-4',
              m(".mb-4",
                m(SectionGeneralInformation)
              ),
              m(".mb-4",
                m(SectionTargetInformation)
              ),
              (inputFilter.surveyType.code == "N" || inputFilter.surveyType.code == "Y") &&
              m(".mb-4",
                m(SectionOtherInformation)
              ),
              m('.d-flex.gap-2.justify-content-end.mt-5',
                m('button.btn.btn-primary[type=button]', { onclick: () => { finalizeData(vnode.attrs.surveyViewState); } },
                  surveyName == "" ? this.getText("LT00000017", "Register") : this.getText("LT00000498", "Update")
                ),
                surveyName != "" && m('button.btn.btn-primary[type=button]', {
                  onclick: () => {
                    vnode.attrs.surveyViewState.clearState();
                    BeforeCopyData();
                  }
                },
                  this.getText("LT00000541", "Copy")
                ),
                surveyName == "" && m('button.btn.btn-white[type=button]', { onclick: onClear },
                  this.getText("LT00000031", "Clear")
                ),
              )
            )
          )
        ),
        m(Dialog, {
          isOpen: _isCopyOpen,
          transitionDuration: 200,
          closeOnOutsideClick: false,
          onClose: () => { _isCopyOpen = false; },
          title: this.getText("LT00000043", "Confirm"),
          content: m(ConfirmationDialogView, { text: this.getText("EM00000371", "Are you sure you want to copy this survey?") }),
          "class": "cui-dialog",
          footer: [
            m(Button, {
              label: this.getText("LT00000024", "No"),
              onclick: () => { _isCopyOpen = false; }
            }),
            m(Button, {
              label: this.getText("LT00000023", "Yes"),
              intent: Intent.PRIMARY,
              onclick: CopyData
            })
          ]
        }),
        m(Dialog, {
          isOpen: _isPreviewOpen,
          onClose: () => { _isPreviewOpen = false; },
          transitionDuration: 200,
          closeOnOutsideClick: false,
          title: this.getText("LT00000499", "Image Preview"),
          content: m('img[src="' + _base64Image + '"]', { "style": "width:100%;height:100%" }),
          "class": "cui-dialog-sm"
        }),
        m(messageComponent, { isOpen: isMsgOpen, message: showMsg, title: msgTitle, onClosed: () => { redirect() } })
      ), this.getBaseViews()];
    }
  }
}
